import { useState, useRef } from 'react';
import { Card, Carousel } from 'antd';

export const AnimatedRewardCard = ({ item, onClick, type = 'collection' }) => {
	const [isHovering, setIsHovering] = useState(false);
	const carouselRef = useRef(null);
	const coverImage =
		type === 'collection' ? item.coverImage : item.coverImage?.src;
	const thumbnails =
		(type === 'collection'
			? item.thumbnails
			: item?.mediaItems?.map((mediaItem) => mediaItem.src)) || [];
	if (coverImage && thumbnails?.[0] !== coverImage) {
		thumbnails.unshift(coverImage);
	}
	const name = type === 'collection' ? item.name : item.title;

	return (
		<Card
			hoverable
			style={{ borderRadius: '14px', overflow: 'hidden' }}
			onMouseEnter={() => setIsHovering(true)}
			onMouseLeave={() => {
				setIsHovering(false);
				carouselRef.current?.goTo(0, false);
			}}
			cover={
				<div style={{ height: 220, overflow: 'hidden', position: 'relative' }}>
					<div
						style={{
							position: 'absolute',
							top: 0,
							left: 0,
							width: '100%',
							height: 220,
							opacity: 1,
							transition: 'opacity 0.4s ease-in-out',
							zIndex: 2,
						}}
					>
						<Carousel
							ref={carouselRef}
							autoplay={isHovering ? true : false}
							dots={false}
							effect="fade"
							autoplaySpeed={2500}
							pauseOnHover={false}
							speed={600}
							style={{ height: 220 }}
						>
							{thumbnails.map((thumbnail, index) => (
								<div key={item.id + index}>
									<img
										alt={name}
										src={thumbnail}
										style={{
											height: 240,
											width: '100%',
											objectFit: 'cover',
											display: 'block',
										}}
									/>
								</div>
							))}
						</Carousel>
					</div>
				</div>
			}
			onClick={() => onClick(item)}
		>
			<Card.Meta
				title={
					<div
						style={{
							whiteSpace: 'normal',
							overflow: 'visible',
							textOverflow: 'unset',
							wordWrap: 'break-word',
							fontWeight: 600,
						}}
					>
						{name}
					</div>
				}
			/>
		</Card>
	);
};
